<template>
  <div id="Tab8">
    <ValidationObserver
      ref="formValidator"
      v-slot="{
        dirty,
      }"
    >
      <SaveObserver :dirty="dirty">
        <div v-if="isPs" class="tab-content">
          <!-- Section A -->
          <SectionTitle
            icon="fas fa-id-card"
            content="VI. Otras consideraciones y servicios:"
            container-class="tag-badge-main-info mt-5 mb-4"
          />
          <Error
            v-if="controversyVI && controversyVI.existControversy"
            is-alert-mode
            :message="
              '<b>Parte en Controversia: </b>' +
                controversyVI.informationMessage
            "
          />
          <SectionTitle
            :has-line="true"
            content="A. Grado en el que recibirá acceso curricular:"
            container-class="mb-4"
          />
          <div class="row-group  ml-3">
            <div class="row">
              <div class="col-lg-3 inputal">
                <CustomInput
                  v-model="placementsPs.grade"
                  class="readonly"
                  :disabled="true"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- VII. Análisis -->
        <div v-if="isPs">
          <SectionTitle
            icon="fas fa-map-marker-alt"
            content="VII. Análisis"
            container-class="tag-badge-main-info mt-4 mb-4"
          />
          <Error
            v-if="controversyVII && controversyVII.existControversy"
            is-alert-mode
            :message="
              '<b>Parte en Controversia: </b>' +
                controversyVII.informationMessage
            "
          />
          <div class="mt-4">
            <SectionTitle
              :has-line="true"
              content="A. Alternativa de Ubicación"
              container-class="mb-4"
            />
            <div class="ml-3 mt-1">
              <strong>Alternativas de ubicación recomendada:</strong>
              <span>{{ placementsPs.alternativeLocation }}</span>
            </div>
          </div>
          <div class="mt-4">
            <SectionTitle
              :has-line="true"
              content="B. Escuela privada donde el estudiante estará ubicado por decisión de sus padres (localización)"
              container-class="mb-4"
            />
            <div class="text-center mt-1">
              <BoxIconButton
                v-show="
                  showAdd &&
                    isPs &&
                    currentPeiStatus == peiStatus.Borrador &&
                    placementsPs.unilateralLocation.id == 0 &&
                    canEditTab8
                "
                title="Presione aquí para realizar Búsqueda de Ubicación Unilateral"
                icon="fas fa-file-plus "
                @click="onClickShowLocation()"
              />
              <Error
                v-if="
                  validationTriggered.validation &&
                    currentPeiStatus == peiStatus.Borrador &&
                    placementsPs.unilateralLocation.id == 0 &&
                    canEditTab8
                "
                :message="resources['R03200127']"
                variant="no-border"
              />
              <StudentLocation
                class="ml-1"
                :visible="placementsPs.unilateralLocation.id != 0"
                :school-name="placementsPs.unilateralLocation.locationName"
                :phone="placementsPs.unilateralLocation.telephone"
                :town="placementsPs.unilateralLocation.cityName"
                :address="
                  placementsPs.unilateralLocation.addressLine1 +
                    ' ' +
                    placementsPs.unilateralLocation.addressLine2
                "
                :zip-code="placementsPs.unilateralLocation.zipCode"
                :is-pei-draft="
                  currentPeiStatus == peiStatus.Borrador && canEditTab8
                "
              />
            </div>
          </div>
        </div>
        <!-- Seccion A. Alternativa Ubicacion -->
        <div v-if="!IsLocationRejected && !isPs">
          <SectionTitle
            icon="fas fa-map-marker-alt"
            content="VIII. Análisis de Alternativa de Ubicación y Servicios"
            container-class="tag-badge-main-info mt-5 mb-4"
          />
          <Error
            v-if="controversyVIII && controversyVIII.existControversy"
            is-alert-mode
            :message="
              '<b>Parte en Controversia: </b>' +
                controversyVIII.informationMessage
            "
          />

          <SectionTitle
            :has-line="true"
            content="A. Alternativa de Ubicación"
            container-class="mb-4"
          />
          <h5 class="p-2 mt-neg-25">
            <strong>
              Seleccione las alternativas de ubicación consideradas. Para
              aquellas que fueron descartadas, indique las razones.
            </strong>
          </h5>

          <Error
            v-if="alertAlternativeUbications"
            is-alert-mode
            :message="resources['0660']"
            variant="withoutspacing"
          />

          <Error
            v-if="
              isDraft &&
                activateAssistantServiceNeedGuideIsOn &&
                isRecommendedAlternativeLocationRegularRoom &&
                hasAnyAssistantServiceNeed
            "
            is-alert-mode
            variant="withoutspacing"
          >
            Estudiante cuenta con un asistente de servicios. Debe documentar
            cómo se integrará al salón. Presione
            <span
              @click="goToRegularRoomQuestionSection"
              style="cursor: pointer; text-decoration: underline;"
            >
              <strong>aquí</strong>
            </span>
            para completar la información.
          </Error>

          <div class="list-group">
            <div href="#" class="list-group-item active text-center">
              Alternativa
            </div>

            <div
              v-for="(item, index) in alternativeUbications"
              ref="alternativeUbicaList"
              :key="item.alternatePlacementCodeId"
              class="list-group-item list-group-item-action"
              :class="{
                disabled:
                  ((!isDraft ||
                    !canEditTab8 ||
                    (index > recommendFlag.index && nextIndex < index) ||
                    !hasSubSectionAinAmendantVIII) &&
                    canUseNewLogic &&
                    !amendantIsEmpty) ||
                  !isDraft ||
                  isPSC,
              }"
            >
              <div class="row mt-1">
                <div class="col-8 pt-3">
                  <div class="col-12">
                    {{ item.alternatePlacementCodeDescription }}
                  </div>
                  <div
                    v-if="
                      index < recommendFlag.index ||
                        (nextIndex > index && nextIndex != -1)
                    "
                    :ref="'discardComment_' + item.alternatePlacementCodeId"
                    class="col-12 p-2"
                  >
                    <ValidationProvider
                      v-slot="{ failedRules }"
                      :name="index + '(razón)'"
                      rules="required"
                    >
                      <textarea
                        v-model="item.discardReasonDescription"
                        type="text"
                        maxlength="300"
                        :disabled="
                          !hasSelectionInAmendant &&
                            canUseNewLogic &&
                            !amendantIsEmpty &&
                            !hasSubSectionAinAmendantVIII
                        "
                        placeholder="Escriba razón para descartarla..."
                        class="form-control"
                      />
                      <p
                        v-if="
                          failedRules &&
                            failedRules.required &&
                            item.discardReasonDescription.trim().length === 0
                        "
                        class="feedback-error-message mt-1"
                      >
                        <i class="fa fa-times-circle" aria-hidden="true" />
                        Favor de documentar la razón por la cual se está
                        eliminando la alternativa.
                      </p>
                      <div class="comment-sub">
                        {{ item.discardReasonDescription.length }} de 300
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-group">
                    <ValidationProvider>
                      <input
                        :id="'deleteflag_' + item.alternatePlacementCodeId"
                        :ref="'deleteflag_' + item.alternatePlacementCodeId"
                        type="radio"
                        class="hidden"
                        :name="'radio' + item.alternatePlacementCodeId"
                        :checked="item.eliminateFlag"
                        :value="item.alternatePlacementCodeId"
                        @click="
                          onDeleteFlagClick(
                            item.alternatePlacementCodeId,
                            index
                          )
                        "
                      />
                      <label
                        class="entry"
                        :for="'deleteflag_' + item.alternatePlacementCodeId"
                      >
                        <div class="circle" />
                        <div class="entry-label">Eliminada</div>
                      </label>

                      <input
                        :id="'recomendflag_' + item.alternatePlacementCodeId"
                        :ref="'recomendflag_' + item.alternatePlacementCodeId"
                        type="radio"
                        class="hidden recommendFlag"
                        :name="'radio' + item.alternatePlacementCodeId"
                        :codigo="item.alternatePlacementCodeId"
                        :checked="item.recommendFlag"
                        :value="item.alternatePlacementCodeId"
                        @click="
                          onRecommendFlagClick(
                            item.alternatePlacementCodeId,
                            index
                          )
                        "
                      />
                      <label
                        class="entry"
                        :for="'recomendflag_' + item.alternatePlacementCodeId"
                      >
                        <div class="circle" />
                        <div class="entry-label">Recomendada</div>
                      </label>
                      <div
                        v-show="item.eliminateFlag || item.recommendFlag"
                        :ref="'selection_' + item.alternatePlacementCodeId"
                        class="highlight"
                      />
                    </ValidationProvider>
                  </div>
                </div>
                <Error
                  v-if="item.alternatePlacementCodeId == suplementaryServices"
                  is-alert-mode
                  :message="resources['R03200154']"
                />
                <Error
                  v-if="
                    item.alternatePlacementCodeId ==
                      alternatePlacementIds.EducacionEspecialEnElAmbienteNatural
                  "
                  is-alert-mode
                  :message="resources['R03200186']"
                />
              </div>
            </div>
          </div>
          <Error
            v-if="noAlternativeSelected"
            :message="resources['8002']"
            variant="withoutspacing no-border pt-16"
          />
          <Error
            v-if="
              validationTriggered.validation &&
                (validationTriggered.hasErrors('Tab8', `8019`) ||
                  validationTriggered.hasErrors('Tab8', `8022`) ||
                  validationTriggered.hasErrors('Tab8', `8023`))
            "
            :message="
              validationTriggered.hasErrors('Tab8', `8019`)
                ? validationTriggered.errors('Tab8', `8019`)
                : validationTriggered.hasErrors('Tab8', `8022`)
                ? validationTriggered.errors('Tab8', `8022`)
                : validationTriggered.errors('Tab8', `8023`)
            "
            variant="withoutspacing no-border pt-16"
          />

          <Error
            v-if="transitionServiceError != null"
            :message="transitionServiceError"
            variant="withoutspacing no-border pt-16"
          />

          <Error
            v-if="
              InvalidQuestion &&
                InvalidQuestion.name === 'False' &&
                validationTriggered &&
                validationTriggered.validation &&
                !validationTriggered.hasErrors('Tab8', `8019`) &&
                !validationTriggered.hasErrors('Tab8', `8022`) &&
                !validationTriggered.hasErrors('Tab8', `8023`)
            "
            :message="InvalidQuestion.value"
            variant="withoutspacing no-border pt-16"
          />
          <Error
            v-if="
              validationTriggered.validation &&
                validationTriggered.hasErrors('Tab8', `TSF`)
            "
            :message="validationTriggered.errors('Tab8', `TSF`)"
            variant="withoutspacing no-border pt-16"
          />
          <Error
            v-if="
              validationTriggered.validation &&
                validationTriggered.hasErrors(
                  'Tab8',
                  `Tab8-PlacedInModifiedClassroomFlag`
                )
            "
            :message="
              validationTriggered.errors(
                'Tab8',
                `Tab8-PlacedInModifiedClassroomFlag`
              )
            "
            variant="withoutspacing no-border pt-16"
          />
        </div>

        <!-- VII. Análisis -->
        <SectionTitle
          :has-line="true"
          content="Información de Escuela"
          container-class="my-4"
          v-if="isPSC"
        />
        <div v-if="isPSC" class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Región:</div>
            <div class="col-lg-3">Distrito:</div>
            <div class="col-lg-3">Municipio:</div>
            <div class="col-lg-3">Escuela:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.regionName }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.districtName }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.municipality }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.schoolCode + ' - ' + model.schoolName }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="isPSC" class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Grado:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                <b>{{ model.schoolGrade }}</b>
              </span>
            </div>
          </div>
        </div>

        <!-- Seccion B. Servicios -->
        <SectionTitle
          v-if="IsLocationRejected && !isPs"
          icon="fas fa-map-marker-alt"
          content="VIII. Análisis de Alternativa de Ubicación y Servicios"
          container-class="tag-badge-main-info mt-5"
        />
        <div class="mt-4">
          <SectionTitle
            v-if="!isPs"
            class="mt-4"
            :has-line="true"
            content="B. Servicios"
            container-class="mb-4"
          />

          <SectionTitle
            v-if="isPs"
            :has-line="true"
            content="C. Servicios"
            container-class="mb-4"
          />
          <div class="mt-neg-25">
            <StrongTitle
              class="ml-2"
              title="Los servicios deben ser añadidos mediante la definición del programa de servicios en el tab IV."
            />
          </div>
          <Services
            :is-valid="IsValidTab"
            :is-draft="isDraft && canEditTab8"
            :can-edit="
              (canEditTab8 &&
                hasSelectioIIinAmendant &&
                hasSubSectionBinAmendantVIII) ||
                !canUseNewLogic ||
                amendantIsEmpty
            "
            :enable-edit="selectedIsValid"
            :items="evaluationServiceList"
            @view="viewServiceDocumentHandler"
            @edit="editServiceHandler"
          />

          <Error
            v-if="
              validationTriggered.validation &&
                evaluationServiceList &&
                evaluationServiceList.length == 0
            "
            :message="resources['8003']"
            variant="withoutspacing no-border"
          />
          <Error
            v-if="
              validationTriggered.validation &&
                validationTriggered.hasErrors('Tab8', `COG`)
            "
            :message="validationTriggered.errors('Tab8', `COG`)"
            variant="withoutspacing no-border pt-16"
          />
          <Error
            v-if="someEvaluationServiceNotCompleted"
            :message="resources['R03200124']"
            variant="withoutspacing no-border"
          />
        </div>
        <!-- Seccion C. Fecha Proyectada -->
        <div v-if="!IsLocationRejected" class="mt-4">
          <SectionTitle
            v-if="isPs"
            :has-line="true"
            content="D. Fecha Proyectada"
            container-class="mb-4 mt-1"
          />

          <SectionTitle
            v-if="!isPs"
            :has-line="true"
            content="C. Fecha Proyectada"
            container-class="mb-4 mt-1"
          />

          <div class="row ml-2 mt-neg-25">
            <div class="col-12 d-inline mt-2">
              <StrongTitle
                title="Fecha proyectada de inicio de los servicios:"
              />
            </div>
            <div class="mt-2 ml-3">
              <ValidationProvider
                name="Fecha Proyectada"
                :rules="`${validationTriggered.validation ? 'required' : ''}`"
                immediate
              >
                <datepicker
                  v-model="proyectedDate"
                  :disabled="
                    ((!isDraft ||
                      !canEditTab8 ||
                      !hasSubSectionCinAmendantVIII) &&
                      canUseNewLogic &&
                      !amendantIsEmpty) ||
                      !isDraft
                  "
                  format="dd/MMM./yyyy"
                  :error="proyectedDateEmptyErrorMsg"
                  :custom-error-msg="proyectedDateEmptyErrorMsg"
                />
              </ValidationProvider>
            </div>
          </div>
          <Error
            v-if="
              validationTriggered.validation &&
                validationTriggered.hasErrors('Tab8', 'C-proyectedDate')
            "
            :message="validationTriggered.errors('Tab8', 'C-proyectedDate')"
            variant="withoutspacing no-border pt-16"
          />
          <Error
            v-if="proyectedDateMessage"
            is-alert-mode
            :message="proyectedDateMessage"
          />
        </div>
      </SaveObserver>
    </ValidationObserver>
  </div>
</template>

<script>
import peiStatus from '@/utils/constants/pei/peiStatus';
import alternatePlacements from '@/utils/constants/alternatePlacements';
import router from '@/router/index';
import '@/assets/css/component/radio-button.css';
import '@/assets/css/component/checkbox.css';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import datepicker from '@/components/common/CustomDatePicker';
import { SectionTitle, BoxIconButton } from '@/components/pei/shared';
import {
  Services,
  StudentLocation,
} from '@/components/pei/tabs/components/tab8';
import { StrongTitle } from '@/components/pei/tabs/components/tab6';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import SaveObserver from '@/components/common/SaveObserver';
import Error from '@/components/common/Error.vue';
import store from '@/store/index';
import CustomInput from '@/components/common/CustomInput';
import resourcesService from '@/services/resources.js';
import peiSections from '@/utils/constants/pei/peiSections.js';
import PeiAnalysisAlternatePlacements from '@/utils/constants/pei/PeiAnalysisAlternatePlacements.js';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import peiAssistantsNeeds from '@/utils/constants/pei/peiAssistantsNeeds';

const SUB_SECTION_A = 41;
const SUB_SECTION_B = 42;
const SUB_SECTION_C = 44;
export default {
  name: 'Tab8',
  mixins: [mixWait, mixAlert],
  components: {
    datepicker,
    Services,
    StrongTitle,
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    SaveObserver,
    Error,
    BoxIconButton,
    StudentLocation,
    CustomInput,
  },
  data() {
    return {
      model: {},
      peiStatus: peiStatus,
      showAdd: false,
      isPs: store.getters.getIsPs,
      currentPeiStatus: store.getters.SelectedPeiStatus,
      placementsPs: {
        grade: '',
        alternativeLocation: '',
        unilateralLocation: {
          id: 0,
          peiCityCode: 0,
          addressLine1: '',
          addressLine2: '',
          locationName: '',
          stateId: 0,
          telephone: '',
          zipCode: '',
          cityName: '',
        },
      },
      regularRoomWithService: '',
      proyectedDate: null,
      proyectedDateMessage: '',
      proyectedDateErrorMessage: '',
      oldProyectedDate: null,
      Info: {},
      evaluationServiceList: [],
      IsLocationRejected: false,
      alternativeUbications: [],
      oldDataAlternativeUbications: [],
      alternativeUbicationErrorMessage: '',
      recommendFlag: {
        index: 0,
        value: 0,
      },
      oldRecommendFlag: {
        index: 0,
        value: 0,
      },
      nextIndex: 0,
      oldNextIndex: 0,
      peiStatusCode: 1,
      showLocationBox: false,
      IsValidTab: true,
      InvalidQuestion: {},
      resources: [],
      hasTransitionServices:
        store.getters.getPeiInfo.transitionServicesFlag == '1',
      isMoreThan16YearsOld: store.getters.getPeiInfo.ageAmt >= 16,
      noAlternativeSelected: false,
      proyectedDateEmptyErrorMsg: '',
      hideSaveButton:
        store.getters.getPeiInfo.peiLocationRejected == '1' &&
        store.getters.getPeiInfo.checklistStatusCode == null,
      suplementaryServices: PeiAnalysisAlternatePlacements.SuplementaryServices,
      canEditTab8: store.getters.HasPermission('pei.editTab8'),
      activateAssistantServiceNeedGuideIsOn: false,
      recommendedLocationId_fromDb: null,
      needsStudentList: [],
    };
  },
  computed: {
    isRecommendedAlternativeLocationRegularRoom() {
      const savedRecommendedLocation = this.oldDataAlternativeUbications ?? [];
      return (
        savedRecommendedLocation.find(
          (x) =>
            x.recommendFlag == '1' &&
            [
              alternatePlacements.SalonRegularConServiciosRelacionados,
              alternatePlacements.SalonRegularConServiciosSuplementarios,
            ].includes(x.alternatePlacementCodeId)
        ) != null
      );
    },
    isPSC() {
      return store.state.pei.configUnilateralFlag == '2';
    },
    alternatePlacementIds() {
      return alternatePlacements;
    },
    selectedIsValid() {
      let isValid = false;
      if (
        this.hasAlternativeSelected &&
        !this.$refs.formValidator.flags.dirty
      ) {
        isValid = true;
      }
      return isValid;
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatus.Borrador;
    },
    isCompleted() {
      return store.getters.SelectedPeiStatus == peiStatus.Completado;
    },
    isSigned() {
      return store.getters.SelectedPeiStatus == peiStatus.Firmado;
    },
    validationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    transitionServiceError() {
      if (
        this.validationTriggered.validation &&
        !this.validationTriggered.hasErrors('Tab8', `TSF`) &&
        this.isMoreThan16YearsOld
      ) {
        const isRegularServiceAndSuplementary =
          this.alternativeUbications.find(
            (x) =>
              x.recommendFlag == '1' &&
              (x.alternatePlacementCodeId ==
                alternatePlacements.SalonRegularConServiciosYAyudaSuplementaria ||
                x.alternatePlacementCodeId ==
                  alternatePlacements.SalonRegularConServiciosRelacionados)
          ) != null;
        if (this.hasTransitionServices && isRegularServiceAndSuplementary) {
          return this.resources['8020'];
        }
        if (!this.hasTransitionServices && !isRegularServiceAndSuplementary) {
          return this.resources['8021'];
        }
        return null;
      }
      return null;
    },
    someEvaluationServiceNotCompleted() {
      return (
        this.validationTriggered.validation &&
        this.revisionNumber === 0 &&
        this.evaluationServiceList?.find((x) => x.isCompleted == '0') != null
      );
    },
    alertAlternativeUbications() {
      return (
        !store.getters.getPeiHasAcademicAreas &&
        this.alternativeUbications &&
        this.alternativeUbications.find(
          (x) =>
            x.recommendFlag == '1' &&
            (x.alternatePlacementCodeId ==
              alternatePlacements.SalonRegularConServiciosYAyudaSuplementaria ||
              x.alternatePlacementCodeId ==
                alternatePlacements.SalonRegularConServiciosDeSalonRecurso)
        )
      );
    },
    hasData() {
      for (let item of this.alternativeUbications) {
        if (item.recommendFlag || item.discardReasonDescription != '') {
          return true;
        }
      }
      return false;
    },
    dictionaryCode() {
      let Codes = [];
      for (let item of this.alternativeUbications) {
        Codes.push(item.alternatePlacementCodeId);
      }
      return Codes;
    },
    hasAlternativeSelected() {
      const alternativeRecommended =
        this.alternativeUbications.filter((x) => x.recommendFlag === true)
          .length > 0;
      return alternativeRecommended;
    },
    hasUbicationEliminatedUncommented() {
      const ubicationRecommended = this.alternativeUbications.find(
        (x) => x.recommendFlag === true
      );
      if (ubicationRecommended) {
        const ubicationWithNoMessage =
          this.alternativeUbications.filter(
            (x) =>
              x.eliminateFlag === true &&
              x.discardReasonDescription.trim().length === 0 &&
              x.alternatePlacementCodeId <
                ubicationRecommended.alternatePlacementCodeId
          ).length > 0;
        return ubicationWithNoMessage;
      }
      return false;
    },
    controversyVI() {
      return store.getters.getPeiControversies(peiSections.VI);
    },
    controversyVII() {
      return store.getters.getPeiControversies(peiSections.VII);
    },
    controversyVIII() {
      return store.getters.getPeiControversies(peiSections.VIII);
    },
    revisionNumber() {
      return store.state.SelectedPeiRevisionNo;
    },
    canUseNewLogic() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
    hasSelectionInAmendant() {
      // validamos que se selecciono en la enmienda la seccion IV-V y no se debe aplicar en la seccion de Servicios
      const sectionsToValidate = [parseInt(peiSections.IVV)];

      return sectionsToValidate.some((sectionId) =>
        this.$store.state['$_admendment'].sections.some(
          (x) => x.sectionId == sectionId
        )
      );
    },
    hasSubSectionAinAmendantVIII() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_A
      );
    },
    hasSubSectionBinAmendantVIII() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_B
      );
    },
    hasSubSectionCinAmendantVIII() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_C
      );
    },
    amendantIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
    canShowSectionEditable() {
      return this.hasSelectionInAmendant && this.canUseNewLogic;
    },
    hasSelectioIIinAmendant() {
      // valida que se selecciono en la enmienda la seccion II y IV-V y unicamente aplica a Servicios
      const sectionsToValidate = [
        parseInt(peiSections.II),
        parseInt(peiSections.IVV),
        parseInt(peiSections.VI),
      ];
      return sectionsToValidate.some((sectionId) =>
        this.$store.state['$_admendment'].sections.some(
          (x) => x.sectionId == sectionId
        )
      );
    },
    hasAnyAssistantServiceNeed() {
      const assistantServiceNeedIds = [
        peiAssistantsNeeds.alimentacion,
        peiAssistantsNeeds.movilidad,
        peiAssistantsNeeds.transportacion,
        peiAssistantsNeeds.higiene,
        peiAssistantsNeeds.sillaDeRueda,
        peiAssistantsNeeds.apoyoConductual,
        peiAssistantsNeeds.cateterizacion,
        peiAssistantsNeeds.colonostomia,
      ];

      return (
        this.needsStudentList.length > 0 &&
        assistantServiceNeedIds.some((id) =>
          this.needsStudentList.some((row) => row.id === id)
        )
      );
    },
  },
  async activated() {
    store.commit('setSaveMethod', this.save);
    store.commit('setResetOriginalDataMethod', this.resetOriginalData);
    store.commit('setSaveBtnVisibility', !this.hideSaveButton);
    await this.GetEvaluationService();
    await this.getSelectedNeedsStudent();

    const currentTab = this.$root.$route.query.tab?.toLowerCase();
    if (
      currentTab &&
      currentTab.indexOf('tab') !== -1 &&
      currentTab !== 'tab8'
    ) {
      this.clearQueryParams();
    }
  },
  methods: {
    async getActivateAssistantServiceNeedGuidearameter() {
      const academicYearId = store.getters.getPeiInfo.academicYearId;
      const { data } = await getSysparameterByNames({
        parameterNames: ['ActivateAssistantServiceNeedGuide'],
        academicYearId,
      });
      this.activateAssistantServiceNeedGuideIsOn =
        data[0]?.staticValue == 'true';
    },
    clearQueryParams() {
      // Clear query params without navigating if already at /pei/detail
      const { path } = this.$root.$route;
      if (
        path === '/pei/detail' &&
        Object.keys(this.$root.$route.query).length > 0
      ) {
        // Replace only if there are params to clear
        this.$root.$router.replace({ path, query: {} });
      } else {
        this.$root.$router.query = {};
      }
    },
    goToRegularRoomQuestionSection() {
      const currentQuery = this.$root.$route.query;
      const targetQuery = {
        tab: 'Tab6',
        section: 'I',
        questionId: '25',
      };

      // Verificar si los query params son diferentes
      const isDifferent =
        currentQuery.tab !== targetQuery.tab ||
        currentQuery.section !== targetQuery.section ||
        currentQuery.questionId !== targetQuery.questionId;

      if (!isDifferent) {
        this.clearQueryParams();
      }

      this.$nextTick(() => {
        this.$root.$router.push({
          path: '/pei/detail',
          query: targetQuery,
        });
        this.$emit('change-tab', targetQuery.tab);
      });
    },
    async getPei() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/pei/getpeitab1?peiId=' + store.getters.SelectedPei)
          .then((res) => {
            self.model = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });

      return promise;
    },
    saveTab() {
      store.dispatch('saveChangesOnForm');
    },
    getErrorMsg(err) {
      if (store.state.pei.peiStatusCode != 1) {
        return null;
      }
      if ((!this.proyectedDate || err) && this.validationTriggered.validation) {
        return this.resources['8004'];
      }
      return null;
    },
    async loadSelectedAcademicAreas() {
      let self = this;
      self
        .$ApiGet('api/pei/GetSelectedPeiServiceAcademicArea', {
          peiId: store.getters.SelectedPei,
        })
        .then((response) => {
          store.commit('setPeiHasAcademicAreas', response.data.length > 0);
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    async loadResources() {
      let resourceCodes = [
        '0660',
        'R03200108',
        'R03200109',
        'R03200110',
        '8002',
        '8003',
        '0663',
        '8020',
        '8021',
        'R03200124',
        '8004',
        '8015',
        'R03200127',
        'R03200154',
        'P90002',
        'R03200186',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    async validate() {
      this.proyectedDateEmptyErrorMsg = '';
      const formValid = await this.$refs.formValidator.validate();

      if (!this.hasAlternativeSelected && !store.getters.getIsPs) {
        this.noAlternativeSelected = true;
        this.ShowToast('Atención', this.resources['8002'], 'error');
        return;
      } else {
        this.noAlternativeSelected = false;
      }

      if (!this.proyectedDate) {
        this.proyectedDateEmptyErrorMsg =
          'El campo de fecha proyectada es requerido.';
        this.ShowToast('Atención', this.proyectedDateEmptyErrorMsg, 'error');
      }
      return formValid && this.proyectedDate;
    },
    async save() {
      let self = this;
      this.proyectedDateErrorMessage = '';
      let isValid = await this.validate();

      if (!isValid) throw true;
      try {
        let analysisAlternatePlacementList = this.alternativeUbications.map(
          (a) => {
            return {
              alternatePlacementCodeId: a.alternatePlacementCodeId,
              alternatePlacementCodeDescription:
                a.alternatePlacementCodeDescription,
              discardReasonDescription: a.discardReasonDescription,
              eliminateFlag: a.eliminateFlag == true,
              recommendFlag: a.recommendFlag == true,
            };
          }
        );

        const data = {
          analysisAlternatePlacementList: analysisAlternatePlacementList,
          peiId: this.$store.getters.SelectedPei,
          proyectedDate: this.proyectedDate,
        };

        //valido el tabVIII
        self.InvalidQuestion = {};
        const response = await this.$ApiPost('api/pei/validtabviii', data);
        let info = response.data;
        self.IsValidTab = info.value;
        let hasError = false;

        info.errors.map((val) => {
          if (val.name == 'False') {
            self.InvalidQuestion = val;
            hasError = true;
            this.ShowToast('Atención', val.value, 'error');
            throw true;
          }
        });

        if (!hasError) {
          await this.$ApiPost('api/pei/savetab8', data);
          this.oldDataAlternativeUbications = this.makeArrayCopyOfObj(
            this.alternativeUbications
          );
          this.ShowToast(
            this.resources['R03200110'],
            this.resources['R03200109'],
            'success'
          );
        }
      } catch ({ response: error }) {
        this.proyectedDateErrorMessage = error.data.message;
        throw true;
      }
    },
    viewServiceDocumentHandler(item) {
      return item; //:/ Validar el porque este metodo
    },
    editServiceHandler(item) {
      store.commit('SetServiceTypeId', item.peiAnalysisServiceCode);
      store.commit('setAnalysisServiceId', item.analysisServiceId);
      let editService = {
        name: 'Service',
        query: {
          isPs: this.isPs,
        },
        params: {
          hasResultSummary: item.hasResultSummary,
          hasAchievementSummary: item.hasAchievementSummary,
        },
      };
      this.$router.push(editService);
    },
    async GetAlternativeUbications() {
      let self = this;
      await self
        .$ApiGet(
          'api/pei/getalternativeubications/' + store.getters.SelectedPei
        )
        .then((response) => {
          self.alternativeUbications = self.makeArrayCopyOfObj(response.data);
          self.oldDataAlternativeUbications = self.makeArrayCopyOfObj(
            response.data
          );

          if (this.isDraft) {
            self.alternativeUbications = self.alternativeUbications.filter(
              (x) =>
                x.alternatePlacementCodeId !=
                alternatePlacements.ServiciosRelacionadosEnOficinaDelProveedor
            );
          } else if (this.isCompleted || this.isSigned) {
            let ambienteNatural = self.alternativeUbications.find(
              (x) =>
                x.alternatePlacementCodeId ==
                alternatePlacements.EducacionEspecialEnElAmbienteNatural
            );
            if (ambienteNatural && ambienteNatural.recommendFlag) {
              self.alternativeUbications = self.alternativeUbications.filter(
                (x) =>
                  x.alternatePlacementCodeId !=
                  alternatePlacements.ServiciosRelacionadosEnOficinaDelProveedor
              );
            } else {
              self.alternativeUbications = self.alternativeUbications.filter(
                (x) =>
                  x.alternatePlacementCodeId !=
                  alternatePlacements.EducacionEspecialEnElAmbienteNatural
              );
            }
          }

          let hasAlternativeAcademicUbications = self.alternativeUbications.find(
            (x) =>
              x.recommendFlag == '1' &&
              (x.alternatePlacementCodeId ==
                alternatePlacements.SalonRegularConServiciosYAyudaSuplementaria ||
                x.alternatePlacementCodeId ==
                  alternatePlacements.SalonRegularConServiciosDeSalonRecurso)
          );
          store.commit(
            'setPeiHasAlternativeAcademicUbications',
            hasAlternativeAcademicUbications != null
          );
          this.disabledItems();
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R03200108'], 'error');
        });
    },
    makeArrayCopyOfObj(array) {
      return array.map((obj) => {
        return { ...obj };
      });
    },
    onDeleteFlagClick(codeId, index) {
      //Check that the next index is out of limits
      if (this.alternativeUbications[index].eliminateFlag) return;

      this.nextIndex = index + 1;

      this.alternativeUbications[index].eliminateFlag = true;
      this.alternativeUbications[index].recommendFlag = false;

      const clearAlternativeThatComesAfter = this.alternativeUbications.filter(
        (item, ind) => ind > index
      );

      if (clearAlternativeThatComesAfter.length > 0) {
        clearAlternativeThatComesAfter.forEach((x) => {
          x.eliminateFlag = null;
          x.recommendFlag = null;
        });
      }
    },
    onRecommendFlagClick(codeId, rowIndex) {
      this.nextIndex = -1;

      this.recommendFlag.index = rowIndex;
      this.recommendFlag.value = codeId;

      const alternativeUbicationFound = this.alternativeUbications.find(
        (a) => a.alternatePlacementCodeId === codeId
      );

      if (alternativeUbicationFound) {
        alternativeUbicationFound.recommendFlag = true;
        alternativeUbicationFound.eliminateFlag = false;
        alternativeUbicationFound.discardReasonDescription = '';
      }

      this.alternativeUbications.map((item, ind) => {
        if (ind !== rowIndex) {
          item.recommendFlag = false;
          item.eliminateFlag = true;
        }
        if (ind > rowIndex) {
          item.discardReasonDescription = '';
        }
      });
    },
    disabledItems() {
      if (this.hasData) {
        let recommendItem = this.alternativeUbications.find(
          (alt) => alt.recommendFlag === true
        );

        if (recommendItem) {
          this.recommendFlag.value = recommendItem.alternatePlacementCodeId;
          this.recommendFlag.index = this.alternativeUbications.indexOf(
            recommendItem
          );
        } else {
          let eliminatedItems = this.alternativeUbications.filter(
            (item) => item.eliminateFlag === true
          ).length;
          if (eliminatedItems === this.alternativeUbications.length) {
            this.nextIndex = this.alternativeUbications.length;
          } else if (eliminatedItems > 0) {
            let maxIndex = 0;
            this.alternativeUbications.map((item, ind) => {
              if (item.eliminateFlag) {
                maxIndex = ind;
              }
            });
            this.nextIndex = maxIndex;
          }
        }
      }
      this.oldRecommendFlag = { ...this.recommendFlag };
      this.peiStatusCode = store.state.pei.peiStatusCode;
    },
    isDisabledItem() {
      let isDisabled = false;
      if (this.hasData) {
        for (let index in this.alternativeUbications) {
          if (this.alternativeUbications[index].recommendFlag) {
            this.recommendFlag.value = this.alternativeUbications[
              index
            ].alternatePlacementCodeId;
            isDisabled = this.recommendFlag.index == index;
          }
        }
      }
      return isDisabled;
    },
    resetOriginalData() {
      this.alternativeUbications = this.makeArrayCopyOfObj(
        this.oldDataAlternativeUbications
      );
      this.proyectedDate = this.oldProyectedDate;
      this.nextIndex = this.oldNextIndex;
      this.recommendFlag = { ...this.oldRecommendFlag };
    },
    async getProjectedDate() {
      const studentSieId = this.$store.getters['$_student/StudentSie'];
      const peiId = this.$store.getters.SelectedPei;
      const { data: response } = await this.$ApiGet(
        `/api/pei/getproyecteddate/${studentSieId}/${peiId}`
      );

      this.proyectedDateMessage = response.message;
      if (response.projectedDate != null) {
        this.proyectedDate = new Date(response.projectedDate);
        this.oldProyectedDate = new Date(response.projectedDate);
      }
    },
    onClickShowLocation() {
      router.push({ path: '/pei/detail/unilaterallocations' });
    },
    async getPlacementPs() {
      const peiId = this.$store.getters.SelectedPei;
      const { data: response } = await this.$ApiGet(
        `/api/pei/getplacementps/${peiId}`
      );

      this.placementsPs = response;
    },
    async GetEvaluationService() {
      const { data: response } = await this.$ApiGet(
        `/api/pei/getallanalysisservice/${this.$store.getters.SelectedPei}`
      );
      this.evaluationServiceList = response;
    },
    async getSelectedNeedsStudent() {
      try {
        const { data } = await this.$ApiGet(
          'api/pei/GetSelectedPeiServiceNeed',
          { peiId: this.$store.getters.SelectedPei }
        );

        if (!data) {
          return;
        }

        this.needsStudentList = data.map((item) => ({
          id: item.id,
          name: item.name,
          isJustifiedNeed: item.justifiedFlag,
          hasIcon: false,
        }));
      } catch (error) {
        console.error(
          'Ha ocurrido un error al obtener las necesidades del estudiante'
        );
      }
    },
  },

  async mounted() {
    this.loadResources();
    this.GetAlternativeUbications();
    this.loadSelectedAcademicAreas();
    this.getActivateAssistantServiceNeedGuidearameter();
    await this.getPei();
    if (this.isPs) {
      this.getPlacementPs();
    }
    this.IsLocationRejected =
      this.$store.getters.SelectedPeiLocationRejected == '1';
    this.showAdd = true;
    this.getProjectedDate();
  },
};
</script>

<style scoped>
.feedback-error-message {
  text-align: left;
  font: Regular 14px/24px Lato;
  letter-spacing: 0;
  color: #ff5b5c;
  opacity: 1;
}
.info-title {
  margin-left: 17px;
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.disabled {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border: 1px solid #e1e1e1;
  opacity: 1;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #2db782;
  background-color: #2db782;
  border-color: #2db782;
}

.col-2 {
  padding: 0px;
}

.col-4 {
  padding-left: 0px;
  padding-right: 0px;
}

.list-group-item.active {
  background-color: #3f5b60 !important;
  border: none;
}

.list-group-item-action {
  padding-top: 0px;
  padding-bottom: 0px;
}

.input-group .hidden {
  display: none;
}
.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
  width: 9pc;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 8px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
/* Landscape phones and down */
@media (max-width: 665px) {
  .input-group .hidden:nth-child(3):checked ~ .highlight {
    transform: translateY(35px);
  }
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
.comment-sub {
  font-weight: 100 !important;
  margin-left: 5px;
}
.error {
  color: #ff5b5c;
  font-weight: 200;
}
.subtitle {
  border: 1px solid #d9e5df;
  height: 30px;
  width: 25% !important;
  border-radius: 21px;
  padding-left: 8px;
  padding-top: 2px;
}

.section-title-box {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  padding: 7px;
}

.section-title-box span {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  margin-left: 10px;
}
.spacing {
  height: 22px;
}
.inputal {
  margin-left: 8px;
  margin-top: 4px;
}

.footer-success {
  margin: 8px !important;
}

.mt-neg-25 {
  margin-top: -25px !important;
}
</style>
